import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const {
  trigger: tabsTrigger,
  list: tabsList,
  separator: tabsSeparator
} = semanticThemeTokens.tabs;

export const tabsListStyle = style({
  display: "flex",
  gap: primitiveTokens.sizing["2x"],
  padding: primitiveTokens.sizing["0.25x"],
  borderRadius: primitiveTokens.radii.sm,
  borderWidth: primitiveTokens.borderWidth.default,
  backgroundColor: tabsList.backgroundColor,
  color: tabsList.color,

  borderStyle: "solid"
});

export const tabsTriggerStyle = style({
  cursor: "pointer",
  fontSize: primitiveTokens.type.xs,
  backgroundColor: tabsTrigger.backgroundColor,
  padding: primitiveTokens.sizing["3x"],
  paddingBlock: 5,
  borderRadius: 6,
  borderWidth: primitiveTokens.borderWidth.default,
  borderStyle: "solid",
  borderColor: tabsTrigger.borderColor,
  color: tabsTrigger.textColor,
  transitionDuration: tabsTrigger.transitionDuration,
  transitionProperty: tabsTrigger.transitionProperty,
  whiteSpace: "nowrap",
  selectors: {
    '&[data-state="active"]': {
      color: tabsTrigger.selected.textColor,
      borderColor: tabsTrigger.selected.borderColor
    },
    '&[data-state="inactive"]:hover': {
      backgroundColor: tabsTrigger.hover.backgroundColor,
      color: tabsTrigger.hover.textColor
    },
    "&[data-disabled]": {
      color: tabsTrigger.disabled.textColor,
      pointerEvents: "none"
    },
    '&[data-state="active"][data-disabled]': {
      borderColor: tabsTrigger.disabled.borderColor
    },
    '&[data-state="active"]:not([data-disabled])': {
      backgroundColor: tabsTrigger.selected.backgroundColor
    },
    "&:focus-visible": {
      boxShadow: tabsTrigger.focus.boxShadow,
      outline: tabsTrigger.focus.outline
    }
  }
});

export const tabsSeparatorStyle = style({
  opacity: 1,
  backgroundColor: tabsSeparator.backgroundColor,
  transitionDuration: primitiveTokens.transitionDuration.default,
  transitionProperty: "opacity",
  width: primitiveTokens.borderWidth.default,
  marginBlock: primitiveTokens.sizing["1x"],
  selectors: {
    "&[data-visible='false']": {
      opacity: 0
    }
  }
});
